<!-- FREEFORM COMPONENT - is not connected to control, we get result by emmiting value outside -->

<mat-form-field class="w-100 mat-select-freeform" [class.error-input]="errorMessage">
  <div class="select-container">
    <mat-select
      [(ngModel)]="selectedValues"
      (selectionChange)="handleSelectionChange($event)"
      [multiple]="multiple"
      [placeholder]="placeholder"
      [class.error-input]="errorMessage"
      [disabled]="isReadonly"
      >
      @for (option of itemsSource; track option) {
        <mat-option [value]="option.value" [disabled]="option.disabled">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </div>
  @if (errorMessage) {
    <mat-hint class="error-message">{{ errorMessage }}</mat-hint>
  }
</mat-form-field>
